module.exports = __webpack_public_path__ + "img/error.e805f82a.png";